import { ChangeValue } from "@similarweb/ui-components";

import { NO_DATA_SIGN } from "app/filters/const";
import type {
    ITrafficDistributionBrandedResponseData,
    ITrafficDistributionDataItem,
    ITrafficDistributionSearchResponseData,
} from "app/pages/keyword-research/website-analysis/pages/seo-overview/types";
import { percentageSignFilter, yAxisChangeFilter } from "app/filters/ngFilters";

import { LegendValuesShare, LegendValuesWrapper } from "./TrafficDistributionStyledComponents";
import type { ITiersConfig, ITrafficTransformedData, TrafficDataType } from "./trafficDistributionTypes";

export const getValueAsPercentage = (value: number): string => {
    return !value ? NO_DATA_SIGN : (percentageSignFilter()(value, 1) as string);
};

export const getLegendValueFilter = (percentage: number, obj: ITrafficTransformedData) => {
    const percentageValue = !percentage ? NO_DATA_SIGN : (percentageSignFilter()(percentage, 1) as string);

    return (
        <LegendValuesWrapper>
            <LegendValuesShare>{percentageValue}</LegendValuesShare>
            <ChangeValue
                isDecrease={obj.change < 0}
                value={yAxisChangeFilter()(obj.change, 0) as string}
            />
        </LegendValuesWrapper>
    );
};

export const transformTrafficData = (
    data: ITrafficDistributionSearchResponseData | ITrafficDistributionBrandedResponseData,
    tiersConfig: ITiersConfig[],
): ITrafficTransformedData[] => {
    if (!data) {
        return tiersConfig.map((config) => ({ ...config, y: 0, percentage: 0, change: 0 }));
    }
    return Object.entries(data)?.map(([key, value]: [TrafficDataType, ITrafficDistributionDataItem]) => {
        const config = tiersConfig.find((tier) => tier.id === key);
        return {
            name: config.name,
            color: config.color,
            y: value.Share,
            total: value.Share,
            visible: true,
            id: key,
            percentage: value.Share,
            change: value.Change,
            value: value.Change,
        };
    });
};
